import { useEffect, useState } from 'react';

// import axios from 'axios';
import useSiteMetadata from './use-site-metadata';
import isBrowser from '../utils/isBrowser';

const GRECAPTCHA_SRC = 'https://www.google.com/recaptcha/api.js';
// const GRECAPTCHA_VERIFY = 'https://www.google.com/recaptcha/api/siteverify';

const useRecaptcha = () => {
  const [hasLoaded, setHasLoaded] = useState(false);
  const { grecaptchaSiteKey } = useSiteMetadata();

  useEffect(() => {
    if (isBrowser()) {
      if (document.querySelector(`script[src="${grecaptchaSiteKey}"]`)) {
        window.grecaptcha?.ready(() => setHasLoaded(true));
      }

      const recaptchaScript = document.createElement('script');
      recaptchaScript.src = `${GRECAPTCHA_SRC}?render=${grecaptchaSiteKey}`;
      recaptchaScript.async = true;
      recaptchaScript.defer = true;
      recaptchaScript.addEventListener('load', () => window.grecaptcha?.ready(() => setHasLoaded(true)));
      document.getElementsByTagName('head')[0].appendChild(recaptchaScript);
    }
  }, [grecaptchaSiteKey]);

  const getToken = async () => {
    try {
      if (isBrowser()) {
        const token = await window.grecaptcha?.execute(grecaptchaSiteKey, {
          action: 'submit',
        });

        return token;
      }
    } catch (error) {
      console.error(`useRecaptcha (getToken): ${error}`);
    }
  };

  // const verifySubmission = async (token?: string) => {
  //   try {
  //     if (!token) return;

  //     const verifySite = await axios({
  //       method: 'POST',
  //       url: GRECAPTCHA_VERIFY,
  //       params: {
  //         // TODO: find best way to get this key from secrets.json
  //         secret: 'secrets.grecaptcha.secret_key',
  //         response: token
  //       }
  //     });

  //     return verifySite;
  //   } catch (error) {
  //     console.error(`useRecaptcha (verifySubmission): ${error}`);
  //   }
  // };

  return { hasLoaded, getToken };
};

export default useRecaptcha;
